module.exports = __webpack_public_path__ + "static/img/5.4df986e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/5.png
// module id = fGna
// module chunks = 0